import React, { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { useAuth } from '../auth';
import { jwtDecode } from 'jwt-decode';
import api from '../api';
import './Login.css';

const Login = () => {
  const navigate = useNavigate();
  const { login } = useAuth();

  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [message, setMessage] = useState('');
  const [isLoading, setIsLoading] = useState(false);

  const handleLogin = async () => {
    setMessage('');
    setIsLoading(true);

    try {
      const response = await api.post('/login', {
        email,
        passwd: password,
      });

      const data = response.data;
      const { token } = data;

      if (!token || typeof token !== 'string') {
        setMessage('Erro no processo de autenticação. Por favor, tente novamente.');
        setIsLoading(false);
        return;
      }

      try {
        const decodedToken = jwtDecode(token);

        // 🔧 aqui o ajuste importante:
        if (String(decodedToken.status) !== '1') {
          setMessage('Usuário desabilitado. Entre em contato com o suporte.');
          setIsLoading(false);
          return;
        }

        localStorage.setItem('authToken', token);
        login(token);

        navigate(
          decodedToken.owner === 'admin'
            ? '/dashboard'
            : '/dashboard-cliente'
        );
      } catch (decodeError) {
        console.error('Erro ao decodificar token:', decodeError);
        setMessage('Erro ao processar informações do usuário. Por favor, tente novamente.');
        setIsLoading(false);
      }
    } catch (error) {
      console.error('Erro no login:', error);

      const msg =
        error.response?.data?.message ||
        'Erro ao realizar o login. Por favor, verifique suas credenciais ou sua conexão.';

      setMessage(msg);
      setIsLoading(false);
    }
  };

  return (
    <div className="login-page">
      <div className="login-container">
        <img
          src={require('../../img/Quantum7.png')}
          alt="Quantum Trades"
          width={150}
          height={200}
        />
        <h2>Bem-vindo à Quantum Trades</h2>
        <p>Insira suas credenciais para acessar sua conta.</p>

        <form className="login-form" onSubmit={(e) => e.preventDefault()}>
          <input
            type="email"
            placeholder="Email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
          />
          <input
            type="password"
            placeholder="Senha"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
          />
          <button type="button" onClick={handleLogin} disabled={isLoading}>
            {isLoading ? 'Entrando...' : 'Login'}
          </button>
        </form>

        {message && (
          <p
            className={`message ${
              message.includes('Erro') ? 'error' : 'success'
            }`}
          >
            {message}
          </p>
        )}

        <div className="login-links">
          <Link to="/cadastro" className="register-button">
            Cadastre-se
          </Link>
        </div>

        <h4
          style={{
            marginBottom: 10,
            color: '#222',
            textAlign: 'center',
            marginTop: 25,
          }}
        >
          Faça o cadastro e entre em contato para liberar sua conta.
        </h4>

        <div
          style={{
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            gap: 10,
            marginTop: 10,
          }}
        >
          <a
            href="https://wa.me/5542984241307"
            target="_blank"
            rel="noopener noreferrer"
            style={{
              color: '#25D366',
              fontWeight: 'bold',
              textDecoration: 'none',
              fontSize: 18,
              display: 'flex',
              alignItems: 'center',
              gap: 6,
            }}
          >
            <span role="img" aria-label="WhatsApp">
              📱
            </span>
            (42) 98424-1307 - WhatsApp
          </a>
          <a
            href="mailto:suporte@quantumtrades.com.br"
            style={{
              color: '#0077b6',
              fontWeight: 'bold',
              textDecoration: 'none',
              fontSize: 18,
              display: 'flex',
              alignItems: 'center',
              gap: 6,
            }}
          >
            <span role="img" aria-label="Email">
              ✉️
            </span>
            suporte@quantumtrades.com.br
          </a>
        </div>
      </div>
    </div>
  );
};

export default Login;
